<template>
    <div class="text-center">
        <div class="m-b-5" v-if="!session.is_completed">
            <a class="btn btn-info" type="button" @click="requestLocation()">
                {{ $t("virtual_visit:request_location") }}
                <i v-if="status == 'in_progress'" class="fa fa-spinner fa-spin"></i>
            </a>

            <a v-if="!client_location && client_location_requested" class="btn btn-info m-l-10" type="button" @click="$emit('finished', step_no, true)">
                {{ $t("virtual_visit:location:continue_without") }}
            </a>
        </div>

        <div v-if="msg">{{ msg }}</div>
        <div v-if="status == 'location_request_denied'">
            <ModeratorEnableLocation />
        </div>

        <div class="vld-parent">
            <loading :active="status == 'in_progress'" :can-cancel="false" :is-full-page="false" vl/>

            <!-- fit-bounds-max-zoom: with a single marker fitBounds ignores
                 :zoom and would jump to max-zoom; OSM tiles end at z19, so
                 max-zoom stays within tile coverage -->
            <k-simple-leaflet-map
                v-if="client_location"
                :fullscreen="true"
                :zoom="15"
                :max-zoom="19"
                :fit-bounds-max-zoom="15"
                :center="client_location"
                :markers="markers"
                :height="200"
            >
            </k-simple-leaflet-map>
        </div>
    </div>
</template>

<script>
import KSimpleLeafletMap from "@/components/k-leaflet-map/KSimpleLeafletMap";
import mixins from "../mixins.js"
import ModeratorEnableLocation from "../instructions/ModeratorEnableLocation.vue";

export default {
    mixins: [ mixins ],
    model: {
        prop: 'session',
        event: 'change'
    },
    props: {
        session: {
            type: Object,
            required: true,
        },
    },
    components: {
        "k-simple-leaflet-map": KSimpleLeafletMap,
        ModeratorEnableLocation,
    },
    data: function () {
        return {
            step_no: 2,

            client_location_requested: false,
            status: null,
            // in_progress
            // failed
            // success
            // location_request_denied
        };
    },
    methods: {
        requestLocation: function () {
            const app = this;
            app.client_location_requested = true;
            app.$store.state.OTsession.signal(
                {
                    type: "location",
                    data: "location_request",
                },
                (error) => {
                    if (error) {
                        app.status = "failed";
                    } else {
                        app.status = "in_progress";
                    }
                }
            );
        },
        handleLocationReported: function (event) {
            const app = this;

            if (event.data === "ERROR_REJECTED") {
                app.notify(
                    this.$t("virtual_visit:location:client_rejected"),
                    "",
                    "error"
                );
                app.status = "location_request_denied";
                return;
            }

            if (event.data === "location_saved") {
                // The client saved its GPS position directly to our backend
                // (#3867) - refetch the session to get client_gps
                app.status = "success";
                app.$emit("reloadSessionData");
                app.$emit("finished", app.step_no);
                app.notify(this.$t("virtual_visit:location:client_received"), "", "success");
            }
        },
        setupOTSessionListeners: function () {
            const app = this;
            if (!app.OTsession) { return; }
            app.OTsession.on("signal", (event) => {
                if (event.type == "signal:location") {
                    app.handleLocationReported(event);
                }
            });
        },
    },
    computed: {
        OTsession() {
            return this.$store.state.OTsession;
        },
        markers() {
            return this.client_location
                ? [{ coordinates: this.client_location }]
                : null;
        },
        msg() {
            let msg;
            if (this.status == "in_progress") {
                msg = this.$t("virtual_visit:location_request:in_progress");
            } else if (this.status == "failed") {
                msg = this.$t("virtual_visit:location_request:error_message");
            }
            return msg;
        },
        client_location() {
            return this.session.client_gps
                ? {
                    lat: parseFloat(this.session.client_gps.coordinates[1]),
                    lng: parseFloat(this.session.client_gps.coordinates[0]),
                }
                : null;
        }
    },
    created() {
        if (this.session.client_gps) {
            this.$emit("finished", this.step_no);
        }
    },
    watch: {
        OTsession: {
            immediate: true,
            handler: function (newVal, oldVal) {
                if (newVal && !oldVal) {
                    this.setupOTSessionListeners();
                }
            },
        },
    },
};
</script>
